import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  isLoginError : boolean = false;
  signInErrorDescription: string = 'פרטי הזדהות לא תקינים';
  isOtpSent: boolean = true;
  OtpSentBy: string  = "";
  isProd: any = environment.production;
  baseUrl: any = environment.baseUrl;

  constructor(public route: ActivatedRoute, private userService : UserService,private router : Router) { }

  ngOnInit() {
    if (this.isProd) {
      if (window.location.href.toLowerCase().startsWith('http://')) {
        //window.location.href = window.location.href.replace('http://', 'https://');;
      }
    }
    let m = this.route.snapshot.queryParamMap.get('m');
  }

  public sendOTP(userName){
      //this.isOtpSent=true;
      this.OtpSentBy = "";
      this.userService.getUserOTP(userName).subscribe((data : any)=>{
        if (data!="")
        {
            this.isOtpSent=true; 
            this.OtpSentBy = data;
        }
      },
      (err : HttpErrorResponse)=>{
        this.isLoginError = true;
      });
  }
  

  public login(userName,password){
     this.userService.userAuthentication(userName,password).subscribe((data : any)=>{
      localStorage.setItem('userToken',data.access_token);
      //this.router.navigate(['main-page']);
      //this.router.navigateByUrl('/main-page');

      //let q = window.location.search;
      let lp = this.route.snapshot.queryParamMap.get('lp');
      if (lp) {
        if (lp.toLowerCase().startsWith('/new-document-profit/')) {
          window.location.href = lp;
        } else {
          window.location.href = "/lpi?lpi=" + encodeURIComponent(lp);
        }
      } else {
          window.location.href = "/main-page";
      }
      
    },
    (err : HttpErrorResponse)=>{ 
      if (err.error && err.error.error_description) {
        this.signInErrorDescription = err.error.error_description;
      } else {
        this.signInErrorDescription = 'פרטי הזדהות לא תקינים';
      }
      this.isLoginError = true;
    });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/user/sign-in/sign-in.component.ts